export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/ir85ihq4_IMG_3021.png",
  trainer: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/36i7qjas_DSC07972.jpeg",
  trainerAlt: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/rt4vg9zy_DSC07976.jpeg",
  hero: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/36i7qjas_DSC07972.jpeg",
  benefit: "https://static.prod-images.emergentagent.com/jobs/99a1a268-e2f8-4c25-a2da-9e274140a6bc/images/5da682bbc307bb683e230f9f9bc13bb36b9a3ac6a0f3058815b670f334dc9b13.png",
  community: "https://images.unsplash.com/photo-1597736960442-d613cca349db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGNvbW11bml0eSUyMGxhdWdoaW5nJTIwZGFya3xlbnwwfHx8fDE3Nzk5NTI2MDh8MA&ixlib=rb-4.1.0&q=85",
  course: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/rt4vg9zy_DSC07976.jpeg",
  group: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/27mgg0bq_IMG_6325.jpeg",
  dressCode: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/bcl35cpw_977854F9-5D4A-4CAF-8212-F3617D84A49D.png",
};

export const STUDIO_ADDRESS = {
  street: "Krakowska 56-62",
  city: "Wrocław",
  full: "Krakowska 56-62, Wrocław",
  // Open in Google Maps
  mapUrl: "https://maps.google.com/?q=Krakowska+56-62+Wrocław",
};

export const HERO_VIDEO =
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/zi159ohn_20251221_C1879.mov";

export const ATMOSPHERE_VIDEO =
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/929rccgl_IMG_5823.mov";

export const MOMENT_VIDEO_1 =
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/pedsb6lw_IMG_8791.mov";

export const MOMENT_VIDEO_2 =
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/uey2ythu_20251221_C1880.mov";

export const INSTAGRAM_URL =
  "https://www.instagram.com/grand_dance_studio_wro?igsh=YXBjMnp0YjNsb3d1&utm_source=qr";

export const STRIPE_COURSE_LINK =
  process.env.REACT_APP_STRIPE_COURSE_LINK ||
  "https://buy.stripe.com/eVq3cveoD4cq9bz0Kz1RC00";

export const STRIPE_TRIAL_LINK =
  process.env.REACT_APP_STRIPE_TRIAL_LINK ||
  "https://buy.stripe.com/28E00jfsH9wK4Vjal91RC02";

// All groups — beginner STEP I is trial-bookable (Alina Fri). Anastasia's Tue/Thu/Sat groups are FULL (soldOut) — next enrollment in March
export const GROUPS = [
  { value: "fri-1900-alina", label: "П'ятниця · 19:00 · STEP I · тренерка Аліна · Piłsudskiego 74", level: "STEP I", primary: true, trainer: "Аліна", address: "Piłsudskiego 74" },
  { value: "tue-2000-nastya", label: "Вівторок · 20:00 · STEP I · тренерка Анастасія · Krakowska 56-62", level: "STEP I", primary: true, trainer: "Анастасія", address: "Krakowska 56-62", soldOut: true },
  { value: "thu-1800-nastya", label: "Четвер · 18:00 · STEP I · тренерка Анастасія · Krakowska 56-62", level: "STEP I", primary: true, trainer: "Анастасія", address: "Krakowska 56-62", soldOut: true },
  { value: "sat-1200-nastya", label: "Субота · 12:00 · STEP I · тренерка Анастасія · Krakowska 56-62", level: "STEP I", primary: true, trainer: "Анастасія", address: "Krakowska 56-62", soldOut: true },
  { value: "tue-1800-step2", label: "Вівторок · 18:00 · STEP II", level: "STEP II" },
  { value: "wed-1100-step2", label: "Середа · 11:00 · STEP II", level: "STEP II" },
  { value: "thu-1900-step2", label: "Четвер · 19:00 · STEP II", level: "STEP II" },
  { value: "sat-1300-step2", label: "Субота · 13:00 · STEP II", level: "STEP II" },
  { value: "tue-1900-stars", label: "Вівторок · 19:00 · STARS", level: "STARS" },
  { value: "thu-2000-stars", label: "Четвер · 20:00 · STARS", level: "STARS" },
  { value: "sat-1400-stars", label: "Субота · 14:00 · STARS", level: "STARS" },
];

export const ALINA_ADDRESS = {
  street: "Piłsudskiego 74",
  city: "Wrocław",
  full: "Piłsudskiego 74, Wrocław",
  mapUrl: "https://maps.google.com/?q=Piłsudskiego+74+Wrocław",
};

export const TESTIMONIAL_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/orathds3_IMG_9145.jpeg",
    name: "Уляна",
    short: "Я вилетіла на крилах",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/xoxcxin1_IMG_9067.jpeg",
    name: "учениця",
    short: "Я спокійна, щаслива, задоволена",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/e2lmr6bu_IMG_6763.png",
    name: "Kateryna",
    short: "Це те, що мені потрібно",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/h29z17g9_IMG_9756.jpeg",
    name: "учениця",
    short: "Аж до мурах! Просто вау",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/7ivzhck9_IMG_3394.png",
    name: "Mara",
    short: "Дякую за сьогоднішню програму",
  },
];

// "Що отримують учениці у Grand Dance Studio" — реальні скріни-відповіді з опитування
export const STUDENT_OUTCOMES = [
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/0zm29g6v_IMG_6519.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/zsqisuwe_IMG_6520.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/fed62ipp_IMG_6520.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/8jd9fdib_IMG_6519.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/b3xytgmn_IMG_6520.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/7onaekde_IMG_6520.jpeg",
  "https://customer-assets.emergentagent.com/job_grand-latina/artifacts/yd6qoshg_IMG_6519.jpeg",
];

export const SCHEDULE = {
  step1: {
    code: "STEP I",
    title: "Початковий рівень",
    sub: "Раз на тиждень · Обери одну групу",
    open: true,
    slots: [
      { day: "Четвер", time: "18:00" },
      { day: "Субота", time: "12:00" },
    ],
  },
  step2: {
    code: "STEP II",
    title: "Продовжуючий · від 1 року",
    sub: "Для тих, хто вже відчуває базу",
    open: false,
    slots: [
      { day: "Вівторок", time: "18:00" },
      { day: "Вівторок", time: "20:00" },
      { day: "Середа", time: "11:00" },
      { day: "Четвер", time: "19:00" },
      { day: "Субота", time: "13:00" },
    ],
  },
  stars: {
    code: "STARS",
    title: "Просунутий · від 2 років",
    sub: "Закриті групи з досвідом",
    open: false,
    slots: [
      { day: "Вівторок", time: "19:00" },
      { day: "Четвер", time: "20:00" },
      { day: "Субота", time: "14:00" },
    ],
  },
};
